import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaPhone, FaTimes, FaAngleDown, FaAngleLeft, FaAngleRight, FaLink } from "react-icons/fa";
import { ENQUIRE_NOW_API, FETCH_PRODUCT_DATA_API } from "../../Api";
import axios from "axios";
import { Button, Input, Textarea } from "@material-tailwind/react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dialog, DialogBody, DialogHeader, DialogFooter } from "@material-tailwind/react";
import { Listbox } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid"; // For generating unique IDs
import enviroLoader from "../../../assets/enviroLoader.gif";


const AboutProductPage = () => {

  const [loading, setLoading] = useState(true);

  const [productDetails, setProductDetails] = useState({});

  const [categoryDetails, setCategoryDetails] = useState({
    id: null,
    name: "",
  });

  // ✅ SubCategory Details (id + name)
  const [subCategoryDetails, setSubCategoryDetails] = useState({
    id: null,
    name: "",
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const [quantity, setQuantity] = useState(1);



const addToCart = (product, qty) => {
  if (!product || !product.id) {
    console.error("Invalid product:", product);
    return;
  }

  console.log("Adding to cart:", product, "Qty:", qty);

  // Get existing cart or initialize empty
  const existingCart = localStorage.getItem("cart")
    ? JSON.parse(localStorage.getItem("cart"))
    : [];

  let newCart = [...existingCart];

  // Check if product already exists in cart
  const existingItemIndex = newCart.findIndex(
    (item) => item.product.id === product.id
  );

  if (existingItemIndex !== -1) {
    // ✅ Update quantity
    newCart[existingItemIndex].qty = qty;
    toast.success(`Updated quantity of "${product.name}" in the cart.`);
  } else {
    // ✅ Add new product
    newCart.push({ cartId: uuidv4(), product, qty });
    toast.success(`Added "${product.name}" to the cart successfully.`);
  }

  // ✅ Save updated cart to localStorage
  localStorage.setItem("cart", JSON.stringify(newCart));

  // ✅ Dispatch custom event so other components in the same tab can listen
  window.dispatchEvent(new Event("cartUpdated"));

  console.log("Updated cart in localStorage:", newCart);
};



  const navigate = useNavigate();

  // Scroll to top on mount
useEffect(() => {
  // Scroll to top on mount
  window.scrollTo({ top: 0, behavior: "smooth" });

  const currentPath = window.location.pathname;
  const segments = currentPath.split("/").filter(Boolean);

  const aboutProductIndex = segments.findIndex(
    (segment) => segment.toLowerCase() === "products"
  );

  if (aboutProductIndex !== -1 && segments.length > aboutProductIndex + 2) {
    const docName = decodeURIComponent(segments[aboutProductIndex + 1]);
    const selectedSubCategory = decodeURIComponent(
      segments[segments.length - 2]
    );
    const selectedProductName = decodeURIComponent(
      segments[segments.length - 1]
    );

    const apiURL = `${FETCH_PRODUCT_DATA_API}${docName.replace(/%20/g, " ")}`;

    fetch(apiURL)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch product data");
        return res.json();
      })
      .then((data) => {
        // ✅ Set category details
        setCategoryDetails({ id: data.id, name: data.name });

        // ✅ Sort sub-categories by uId ascending
        const sortedSubCategories =
          data.subcollections?.SubCategories?.sort((a, b) => a.uId - b.uId) || [];

        const subCategoryData = sortedSubCategories.find(
          (sub) => sub.id === selectedSubCategory
        );

        if (subCategoryData) {
          setSubCategoryDetails({
            id: subCategoryData.id,
            name: subCategoryData.name,
          });
        }

        // ✅ Flatten all products (keeping sorted sub-categories)
        const allProducts = sortedSubCategories.flatMap((sub) => {
          const keys = Object.keys(sub.subcollections || {});
          return keys.reduce(
            (acc, key) => acc.concat(sub.subcollections[key] || []),
            []
          );
        });

        // ✅ Find selected product
        const selectedProduct = allProducts.find(
          (product) =>
            product.subCategoryId === selectedSubCategory &&
            product.id === selectedProductName
        );

        setProductDetails(selectedProduct || {});

        // ✅ Initialize quantity from localStorage
        const cart = localStorage.getItem("cart")
          ? JSON.parse(localStorage.getItem("cart"))
          : [];
        const cartItem = cart.find(
          (item) => item.product.id === selectedProductName
        );
        setQuantity(cartItem?.qty || 1);

        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        toast.error(
          "Error fetching product data. Please try again later. " + err.message
        );
        setLoading(false);
      });
  } else {
    console.warn("Invalid product path:", currentPath);
    toast.error("Invalid product path.");
    setLoading(false);
  }

  // Cart update listener
  const handleCartUpdate = () => {
    const cart = localStorage.getItem("cart")
      ? JSON.parse(localStorage.getItem("cart"))
      : [];
    const cartItem = cart.find((item) => item.product.id === productDetails.id);
    console.log("Cart updated event received:", cartItem);
    setQuantity(cartItem?.qty || 1);
  };

  window.addEventListener("cartUpdated", handleCartUpdate);

  // Cleanup
  return () => window.removeEventListener("cartUpdated", handleCartUpdate);
}, [productDetails.id]);




  const inquiryTypes = [
    { key: "sales", label: "Sales Inquiry" },
    { key: "service", label: "Service & Maintenance" },
    { key: "tech_support", label: "Technical Support" },
    { key: "warranty", label: "Warranty" },
    { key: "amc", label: "AMC" },
    { key: "spare_parts", label: "Spare Parts Request" },
    { key: "data_handling", label: "Data Handling" },
    { key: "customization", label: "Customization Inquiry" },
  ];

  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    { question: "What is a Sales Inquiry?", answer: "A sales inquiry helps you understand pricing and purchase options." },
    { question: "How do I request service?", answer: "You can request service for maintenance, repairs, or technical support." },
    { question: "Do you offer rental services?", answer: "Yes, we offer rental services for various equipment." },
    { question: "How can I get spare parts?", answer: "You can request spare parts by selecting the relevant inquiry type." },
    { question: "What is AMC?", answer: "Annual Maintenance Contracts (AMC) provide periodic maintenance for equipment." }
  ];

  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  const [formData, setFormData] = useState({
    orgName: "",
    name: "",
    phone: "",
    email: "",
    enquiryType: [],
    description: "",
    productName: "",
  });

  // Open modal and pre-fill product name
  const openEnquiryModal = () => {
    setIsEnquiryOpen(true);
  };

  // Close modal
  const closeEnquiryModal = () => {
    setIsEnquiryOpen(false);
  };

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  // Handle input changes
  const handleChange = (e) => {
    e.preventDefault();
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle checkbox change
  const handleChipSelect = (selectedKey) => {
    setFormData((prev) => {
      const updatedTypes = prev.enquiryType.includes(selectedKey)
        ? prev.enquiryType.filter((key) => key !== selectedKey)
        : [...prev.enquiryType, selectedKey];

      return { ...prev, enquiryType: updatedTypes };
    });
  };

  const handleRemoveChip = (key) => {
    setFormData((prev) => ({
      ...prev,
      enquiryType: prev.enquiryType.filter((item) => item !== key),
    }));
  };


  // Handle form submission
  const handleSubmit = async (productName) => {

    // Validation: Check if all fields are filled
    if (
      !formData.orgName ||
      !formData.name ||
      !formData.phone ||
      !formData.email ||
      formData.enquiryType.length === 0 ||
      !formData.description
    ) {
      toast.error("Please fill in all fields before submitting.");
      return;
    }

    // Append productName to formData
    const updatedFormData = { ...formData, productName };

    try {
      // API Call (Replace with your actual API endpoint)
      const response = await axios.post(ENQUIRE_NOW_API, updatedFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 200) throw new Error("Failed to submit Enquiry");

      // Success Message
      toast.success("Thanks for reaching out to us! Our sales team will contact you shortly.");


      // Clear Form & Close Modal
      setFormData({
        orgName: "",
        name: "",
        phone: "",
        email: "",
        enquiryType: [],
        description: "",
        productName: "",
      });

      closeEnquiryModal();
    } catch (error) {
      toast.error("Error submitting Enquiry. Please try again.");
      console.error("Submission Error:", error);
    }
  };

  return (
    <>
      {loading ? (
        <div className="flex items-center justify-center h-screen">
          <img
            src={enviroLoader}
            alt="Loading..."
            className="w-40 h-40"
          />
        </div>
      ) : (
        <div className="relative w-full min-h-screen bg-white px-4 sm:px-6 lg:px-12 pt-[100px] pb-12">

          {/* ✅ Breadcrumb Navigation (full width) */}
          <div className="w-full mb-6 text-sm text-gray-600 flex flex-wrap gap-2">
            <span
              onClick={() => navigate(`/products/${categoryDetails.id}`)}
              className="cursor-pointer hover:text-green-600 font-medium"
            >
              {categoryDetails.name}
            </span>
            <span>/</span>
            {subCategoryDetails?.id && (
              <>
                <span
                  onClick={() =>
                    navigate(`/products/${categoryDetails.id}/${subCategoryDetails.id}`)
                  }
                  className="cursor-pointer hover:text-green-600 font-medium"
                >
                  {subCategoryDetails.name}
                </span>
                <span>/</span>
              </>
            )}
            <span className="text-gray-900 font-semibold">{productDetails.name}</span>
          </div>

          {/* ✅ Two-Column Layout */}
          <div className="flex flex-col md:flex-row justify-between gap-8 md:gap-12 w-full">

            {/* LEFT → Product Image Gallery */}
            <div className="w-full md:w-1/2 flex flex-col items-center md:items-start">
              {/* Main Image */}
              <div className="w-full border rounded-lg p-4 flex justify-center items-center bg-gray-50 min-h-[280px] sm:min-h-[350px] md:min-h-[400px]">
                <img
                  src={selectedImage || productDetails.img?.[0]}
                  alt={productDetails.name}
                  className="object-contain w-[250px] h-[250px] sm:w-[350px] sm:h-[350px] md:w-[450px] md:h-[450px]"
                />
              </div>

              {/* Thumbnails */}
              <div className="flex gap-3 sm:gap-4 mt-4 flex-wrap justify-center md:justify-start">
                {productDetails.img?.map((image, idx) => (
                  <img
                    key={idx}
                    src={image}
                    alt={`thumb-${idx}`}
                    className={`w-16 h-16 sm:w-20 sm:h-20 object-contain border rounded-md p-1 cursor-pointer transition ${selectedImage === image
                      ? "border-green-500"
                      : "border-gray-300 hover:border-green-400"
                      }`}
                    onClick={() => setSelectedImage(image)}
                  />
                ))}
              </div>
            </div>

            {/* RIGHT → Product Details */}
            <div className="w-full md:w-1/2 space-y-4 sm:space-y-6">
              {/* Title */}
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-900">
                {productDetails.name}
              </h1>

              {/* Description */}
              <p className="mt-2 text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed">
                {productDetails.desc}
              </p>

              {/* Quantity Selector */}
              <div className="flex items-center gap-3 sm:gap-4">
                <button
                  onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  className="px-3 py-2 border rounded-md bg-gray-100 hover:bg-gray-200"
                >
                  −
                </button>
                <span className="text-base sm:text-lg font-medium">{quantity}</span>
                <button
                  onClick={() => setQuantity((q) => q + 1)}
                  className="px-3 py-2 border rounded-md bg-gray-100 hover:bg-gray-200"
                >
                  +
                </button>
              </div>

              {/* Price + Contact */}
              <div className="text-base sm:text-lg font-medium">
                Price:{" "}
                <button
                  onClick={() => navigate("/contact")}
                  className="text-blue-600 underline hover:opacity-80"
                >
                  Contact Us →
                </button>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 mt-4 sm:mt-6">
                <button
                  className="px-6 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition text-sm sm:text-base"
                  onClick={() => addToCart(productDetails, quantity)}
                >
                  Add to Quote
                </button>
                <button
                  className="px-6 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition text-sm sm:text-base"
                  onClick={openEnquiryModal}
                >
                  Talk to Expert
                </button>
              </div>
            </div>
          </div>

          {productDetails.feat?.length > 0 && (
            <section className="w-full py-16 mt-16">
              {/* Section Heading */}
              <h2 className="text-3xl md:text-4xl font-bold mb-14 text-left">
                <span className="text-green-700">Key Features of </span>
                <span className="text-gray-900">{productDetails.name}</span>
              </h2>

              {/* Features List */}
              <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 max-w-8xl">
                {productDetails.feat.map((feature, idx) => {
                  const parts = feature.split(':');
                  const hasHeading = parts.length > 1;
                  const heading = hasHeading ? parts[0].trim() : null;
                  const desc = hasHeading ? parts.slice(1).join(':').trim() : feature.trim();

                  return (
                    <div
                      key={idx}
                      className="relative bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition duration-300"
                    >
                      {/* Background Number (big faded index) */}
                      <span className="absolute top-4 left-6 text-6xl font-extrabold text-gray-400 select-none">
                        {idx + 1}
                      </span>

                      {/* Feature Content */}
                      <div className="relative z-10 mt-14 text-justify">
                        {heading && (
                          <h3 className="text-lg font-bold text-gray-900 mb-2">{heading}</h3>
                        )}
                        <p className="text-gray-800 text-md leading-relaxed font-medium">
                          {desc}
                        </p>
                      </div>
                    </div>
                  );
                })}

              </div>
            </section>
          )}


          <Dialog open={isEnquiryOpen} handler={closeEnquiryModal} size="xl">
            <DialogHeader className="text-md font-semibold bg-gray-100 p-4 rounded-t-lg">
              Enquire about {productDetails.name}
            </DialogHeader>

            <DialogBody className="p-6 max-h-[70vh] overflow-y-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Left Section: FAQs */}
                <div className="border-r pr-6 space-y-4">
                  <h3 className="text-lg font-semibold text-gray-700 mb-2">Frequently Asked Questions</h3>
                  {faqs.map((faq, index) => (
                    <div key={index} className="p-3 border border-gray-300 rounded-lg bg-white shadow-sm">
                      <div className="flex justify-between items-center cursor-pointer" onClick={() => toggleFAQ(index)}>
                        <h4 className="text-sm font-medium">{faq.question}</h4>
                        <span className="text-gray-500 text-lg">{openFAQ === index ? "−" : "+"}</span>
                      </div>
                      {openFAQ === index && <p className="text-xs text-gray-600 mt-2">{faq.answer}</p>}
                    </div>
                  ))}
                </div>

                {/* Right Section: Form */}
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-gray-700 mb-2">Please Fill out this form, Our team will contact you soon!</h3>
                  <Input
                    type="text"
                    required
                    name="orgName"
                    label="Organization Name"
                    value={formData.orgName}
                    onChange={handleChange}
                    className="border border-gray-300 rounded-md px-3 py-2 w-full text-sm"
                  />
                  <Input
                    type="text"
                    required
                    name="name"
                    label="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    className="border border-gray-300 rounded-md px-3 py-2 w-full text-sm"
                  />
                  <Input
                    type="tel"
                    name="phone"
                    required
                    label="Phone Number"
                    value={formData.phone}
                    onChange={(e) => {
                      // Only digits, max 10 characters
                      const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                      handleChange({ target: { name: 'phone', value: val } });
                    }}
                    maxLength={10}
                    pattern="\d*"
                    className="border border-gray-300 rounded-md px-3 py-2 w-full text-sm"
                  />

                  <Input
                    type="email"
                    name="email"
                    required
                    label="Email"
                    value={formData.email}
                    onChange={handleChange}
                    className="border border-gray-300 rounded-md px-3 py-2 w-full text-sm"
                  />

                  {/* Inquiry Type Chips */}
                  <div className="relative w-full">
                    <Listbox value={formData.enquiryType} onChange={handleChipSelect}>
                      <div className="relative">
                        <Listbox.Button className="w-full border border-gray-300 rounded-md px-3 py-2 flex justify-between items-center text-sm bg-white hover:bg-gray-100">
                          <span>
                            Select Inquiry Type <span className="text-red-500">*</span>
                          </span>
                          <FaAngleDown className="w-5 h-5 text-gray-500" />
                        </Listbox.Button>


                        <Listbox.Options className="absolute mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-40 overflow-auto z-10">
                          {inquiryTypes.map((type) => (
                            <Listbox.Option key={type.key} value={type.key}>
                              {({ active }) => (
                                <div
                                  className={`w-full px-3 py-2 text-left text-sm cursor-pointer ${active ? "bg-green-100" : "bg-white"
                                    }`}
                                >
                                  {type.label}
                                </div>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </div>
                    </Listbox>

                    {/* Selected Inquiry Types as Chips */}
                    {formData.enquiryType.length > 0 && (
                      <div className="mt-2 flex flex-wrap gap-2 border border-gray-300 rounded-md p-2 bg-gray-50">
                        {formData.enquiryType.map((key) => {
                          const selectedType = inquiryTypes.find((type) => type.key === key);
                          return (
                            <div key={key} className="flex items-center bg-green-500 text-white text-xs px-3 py-1 rounded-full">
                              {selectedType?.label}
                              <button onClick={() => handleRemoveChip(key)} className="ml-2 focus:outline-none">
                                <FaTimes className="w-4 h-4 text-white hover:text-gray-200" />
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  {/* Description Box */}
                  <Textarea
                    name="description"
                    label="Describe your inquiry"
                    required
                    value={formData.description}
                    onChange={handleChange}
                    className="border border-gray-300 rounded-md px-3 py-2 w-full h-24 text-sm"
                  />
                </div>
              </div>
            </DialogBody>

            <DialogFooter className="flex justify-end space-x-4 bg-gray-100 p-4 rounded-b-lg">
              <Button className="px-4 py-2 bg-gray-400 text-white rounded-md text-sm" onClick={closeEnquiryModal}>
                Cancel
              </Button>
              <Button className="px-4 py-2 bg-green-500 text-white rounded-md text-sm hover:bg-green-600"
                onClick={() => handleSubmit(productDetails.name)}>
                Submit
              </Button>
            </DialogFooter>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={true}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Dialog>

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      )}
    </>
  );

};

export default AboutProductPage;
